module.exports = __webpack_public_path__ + "hk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/hk.svg
// module id = 591
// module chunks = 0